module.exports = __webpack_public_path__ + "static/media/a-1-c.65eb2ee9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-1-c.jpg
// module id = 1090
// module chunks = 33